import type { PopoverItemProps } from '../../Popover/PopoverItem/PopoverItem';
import type { TopbarActionButtonProps } from './base/TopbarActionButton';

import { useTranslation } from 'react-i18next';

import { PlusDoubleCircleIcon } from '../../../images/shapes';

import TopbarActionButton from './base/TopbarActionButton';

const TopbarDuplicateButton = (
  props: TopbarActionButtonProps & PopoverItemProps,
) => {
  const { t } = useTranslation();

  return (
    <TopbarActionButton
      label={t('Global.Duplicate')}
      iconImage={<PlusDoubleCircleIcon className="w-5" />}
      additionalIconClasses="w-5"
      testIdSuffix="duplicate"
      {...props}
    />
  );
};

export default TopbarDuplicateButton;
